/**
 * Types of button appearance.
 * @public
 */
import type { Button } from '@ni/fast-foundation';

export {
    ButtonAppearance,
    ButtonAppearanceVariant
} from '../patterns/button/types';
export type ButtonType = Button['type'];
